export enum ENUM_PERFORMANCE_STATUS {
  PENDING = "pending",
  APPROVED = "approved",
  AUTO_APPROVED = "auto_approved",
  REJECTED = "rejected",
  CANCELLED = "cancelled",
}
export enum ENUM_PERFORMANCE_CYCLE_STATUS {
  PENDING = "pending",
  COMPLETED = "completed",
  IN_PROGRESS = "in_progress",
}

export enum ENUM_PERFORMANCE_CYCLE_TYPE {
  WEEKLY = "weekly",
  MONTHLY = "monthly",
  QUARTERLY = "quarterly",
  ANNUALLY = "annually",
}
